import ControlPanelController from "./control_panel_controller"

export default class extends ControlPanelController {
  static values = {
    consultantsUrl: String,
    contractorsUrl: String
  }

  async toggleConsultants(event) {
    await this._toggle(this.consultantsUrlValue, event.currentTarget)
  }

  async toggleContractors(event) {
    await this._toggle(this.contractorsUrlValue, event.currentTarget)
  }

  async _toggle(url, checkbox) {
    const checked = checkbox.checked
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: this._headers(),
        body: JSON.stringify({ can_create_folders: checked ? "true" : "false" })
      })
      if (response.ok) {
        this._showToast("Updated successfully")
      } else {
        checkbox.checked = !checked
        this._showToast("Error updating", "error")
      }
    } catch {
      checkbox.checked = !checked
      this._showToast("Network error", "error")
    }
  }
}
